import * as React from 'react';

import { usePathname } from 'expo-router';

import { routes } from 'utils/routing';

import { useTopServiceModeDetails } from './hooks/use-top-service-details';
import { TopServiceModeView } from './top-service-mode.view';

/**
 *
 * TopServiceMode purpose
 *
 */
export const TopServiceMode = ({ isInCart = false }: { isInCart?: boolean }) => {
  const pathname = usePathname();
  const topServiceModeDetails = useTopServiceModeDetails();

  if (pathname === routes.account) {
    return null;
  }

  return <TopServiceModeView {...topServiceModeDetails} isInCart={isInCart} />;
};
